<template>
  <div class="container">
    <p class="current">当前位置：<span>咨询列表</span></p>
    <div class="session-box">
     
      <Menu></Menu>
      <div class="session-main">
        <div>
          <div class="vsHeadTabs vsflex">
            <div class="vsitem  vscenter">
              <div class="" :class="chat_type == 'chat_expert'?'vsactived':'vsnormal'" v-if="IsCustUser == 0 && IsExpert == 0">
                <el-button :type="chat_type == 'chat_expert'?'primary':''" @click="vsTabs('chat_expert')">专家咨询</el-button>
              </div>
            </div>
            <div class="vsitem  vscenter" v-if="IsExpert == 1">
              <div class="" :class="chat_type == 'chat_user'?'vsactived':'vsnormal'">
                <el-button :type="chat_type == 'chat_user'?'primary':''"  @click="vsTabs('chat_user')">会员咨询</el-button>
              </div>
            </div>
            <div class="vsitem  vscenter" v-if="IsCustUser == 0">
              <div class="" :class="chat_type == 'chat_service'?'vsactived':'vsnormal'" >
                <el-button :type="chat_type == 'chat_service'?'primary':''"  @click="vsTabs('chat_service')">客服咨询</el-button>
              </div>
            </div>
            <div class="vsitem  vscenter" v-if="IsCustUser == 1">
              <div class="" :class="chat_type == 'chat_user2'?'vsactived':'vsnormal'">
                <el-button :type="chat_type == 'chat_user2'?'primary':''"  @click="vsTabs('chat_user2')">用户咨询</el-button>
              </div>
            </div>
          </div>
      </div>
      <div v-if="total == 0" class="NullVsData">
        <P>亲，未找到记录~</P>
      </div>
      <!-- 客服聊天 -->
      <div v-if="chat_type == 'chat_service'" class="chatService" >
        <div class="UniMiddle">
          <div>
            <span @click="custuserList">客服：</span>
            <span style="color: #333;font-size: 16px;" @click="custuserList">
              {{CustUserName == '' ? '请选择客服人员':CustUserName}}
            </span>					
          </div>
          <div>
          <!-- <div v-show="CustUserName != ''"> -->
            <div v-show="CustUserName != ''" class="btnblue" @click="ChatService()">进入聊天</div>
          </div>
        </div>
      </div>
      
      <div class="vsList-normal" v-for="(item,index) in vsData" :key="index" @click="VSChat(item)">
        <div class="vstitle">
          <div>
            <!-- 专家咨询或者客服咨询 -->
            <div class="vstext vsflexone" v-if="(chat_type == 'chat_expert')||(chat_type == 'chat_service')" @click="">{{item.to_user_name}}</div>
            <!-- 会员咨询或用户咨询 -->
            <div class="vstext vsflexone" v-if="(chat_type == 'chat_user')||(chat_type == 'chat_user2')">
              <span v-if="(item.to_user_name != '') && (item.to_user_name != null)">{{item.to_user_name}}</span>
              <span v-else>{{item.user_mobile.substring(0,3) + ' ***'}}</span>
            </div>
            <div class="vsinfo" v-if="(chat_type == 'chat_expert')||(chat_type == 'chat_service')">ID: {{item.to_user_id}}</div>
            <div class="vsinfo" v-if="(chat_type == 'chat_user')||(chat_type == 'chat_user2')">ID: {{item.user_id}}</div>
          </div>
          <div>
            <div class="vsinfo">{{item.update_time}}</div>
          </div>
        </div>
        <div class="vsintro">
          <div class="vsflexone">
            <div>{{item.last_message}}</div>
            
          </div>
        </div>
      </div>
      </div>
    </div>

    <el-dialog
        title="请选择客服人员"
        :visible.sync="dialogVisible"
        customClass="chatService"
        >
       <div>
          <div v-for="item in chatServiceList" :key="item.id" class="serviceList" @click="handleCharService(item)">
            <p>
                {{ item.name }}
                <span>ID：{{ item.user_id }}</span>
            </p>

            <p>
                {{ item.updataTime }}
            </p>
          </div>
       </div>
       <div class="serviceNull" v-if="serviceTotal == 0">
          <p>亲，目前没有客服人员在线，请稍后~</p>
       </div>
    </el-dialog>        
  </div>
</template>

<script>
import Menu from './index.vue'
import { getTimeDate,timeDifference } from '@/js/getTime'
export default {
  data(){
    return{
      vsurl:'',
				vstoken:'',
				vspn:0,
				vsData:[],
				pageNum: 1,
				pageSize: 10,
				dian:true,
				xiao:false,
				ma:false,
				isused:'0',
				isexpired:'0',
				curTabIndex:0,
				tabData:[{'item':'专家咨询','value':'chat_expert'},{'item':'会员咨询','value':'chat_user'},{'item':'客服咨询','value':'chat_service'},{'item':'用户咨询','value':'chat_user2'}],
				// chat_type: 'chat_expert',
        chat_type: 'chat_service',
				xlevel:'1',
				UserTotal1:0,
				alltotal:0,
				total: 0,
				CustUsers: [],
				CustUserId: '',
				CustUserName: '',
				IsCustUser: 0,
				IsExpert: 0,
        dialogVisible: false,
        chatServiceList: [],
        serviceTotal: 0
    }
  },
  components:{
    Menu
  },
  watch: {
    '$route' () {
      this._initData();//我的初始化方法
    }
  },
  methods:{
    listByUser(data){
      this.$store.dispatch('session/listByUser',data)
        .then(res =>{
          if(res.ok){
						var resdata = res.data
						var items = res.data.items
						this.total = resdata.total
						var dpn = items.length
						if(dpn > 0){
              items.forEach(item => {
               
                const timeDate = new Date(item.update_time)
                item.update_time = this.getTimeDate(timeDate)
                  
              });
              this.vsData = items
						}
            
					}
        })
    },
    vsTabs(value){
      this.chat_type = value
      // this.$alert(value,'提示')
      this.vsData = []
      let data = {
        pageNum: '1',
        pageSize: '10',
        to_user_id: '', 
        chat_type: this.chat_type
      }
      this.listByUser(data)
    },
    getTimeDate(timeDate){
      const year = timeDate.getFullYear();
      const month = (timeDate.getMonth() + 1).toString().padStart(2, '0');
      const day = timeDate.getDate().toString().padStart(2, '0');
      const hours = timeDate.getHours().toString().padStart(2, '0');
      const minutes = timeDate.getMinutes().toString().padStart(2, '0');
      const seconds = timeDate.getSeconds().toString().padStart(2, '0');
      const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

      return formattedDate
    },
    handleCharService(item){
      // this.chat_type = 'chat_servic'
      // this.CustUserId = item.id
      // this.CustUserName = item.name
      // const { href } = this.$router.resolve({
      //   path: '/session/chatItem',
      //   query: {
      //     chat_type: this.chat_type,
      //     to_user_id: this.CustUserId,
      //     to_user_name: this.CustUserName,
      //     order_no: '',
      //     type: 1
      //   }
      // });
      // window.open(href, '_blank');
    },
    // 客服列表
    custuserList(){
      this.dialogVisible = true
      let data = {}

      this.$store.dispatch('session/listCustUser',data)
        .then(res => {
          this.serviceTotal = res.data.total
          this.chatServiceList = res.data.items

          this.chatServiceList.forEach(item => {
              this.$set(item,'updataTime','')
              item.update_time = getTimeDate(item.update_time)

              item.updataTime = timeDifference(item.update_time)
          });
        })
    },
    // 客服聊天
    ChatService(){
      if(this.chat_type == 'chat_service'){
        const { href } = this.$router.resolve({
          path: '/session/chatItem',
          query: {
            chat_type: this.chat_type,
            to_user_id: this.CustUserId,
            to_user_name: this.CustUserName
          }
        });
        window.open(href, '_blank');
       
      }
    },
    
    VSChat(item){
				var chat_type = this.chat_type
				if(chat_type == 'chat_expert'){

          //专家咨询 
          var url = '/session/chatitemExpert'
          var query ={
            chat_type: chat_type,
            to_user_id: item.to_user_id,
            to_user_name: item.to_user_name,
            order_no: item.order_no
          }			
				}
				if(chat_type == 'chat_user'){
          // 会员咨询
          var url = '/session/chatitemExpert'
          var query ={
            chat_type: chat_type,
            to_user_id: item.user_id,
            to_user_name: item.user_mobile,
            order_no: item.order_no
          }			
				}
				if(chat_type == 'chat_service'){
          // 客服咨询
            var url = '/session/chatItem'
            var query ={
              chat_type: chat_type,
              to_user_id: item.to_user_id,
              to_user_name: item.to_user_name,
              order_no: item.order_no,
              type: 1
            }			
							
				}
				if(chat_type == 'chat_user2'){
          // 用户咨询
          var url = '/session/chatItem'
          var query ={
            chat_type: chat_type,
            to_user_id: item.user_id,
            to_user_name: item.to_user_name,
            type: 2
          }		
				}

        const { href } = this.$router.resolve({
            path: url,
            query: query
          });
          window.open(href, '_blank');
			},
  },
  mounted(){
    if(!localStorage.getItem('token')){
      this.$notify({
      title: '提示',
      message: '未登录或超时，请重新登陆',
      type: 'error'
      })
      this.$router.push('/login')
    }else{
      this.IsExpert = sessionStorage.getItem('qiliangongIsExpert')
      this.IsCustUser = sessionStorage.getItem('qiliangongIsCustUser')
      if(this.IsCustUser == 1){
        this.chat_type = 'chat_user2'
      }
      let data = {
        pageNum: '1',
        pageSize: '10',
        to_user_id: '', 
        chat_type: this.chat_type
      }

      this.listByUser(data)
    }
    


   
  }
}
</script>

<style lang='scss' scoped>

.container{
  width: 1200px; min-height: calc(100vh - 215px);
  margin: 55px auto;
  .current{
    margin-top: -45px;
    position: relative;
    font-size: 17px;
    color: #333;
  }
  .session-box{
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    .session-menu{
      width: 200px;
      background: #fff;
      padding: 15px 15px;
      align-self: flex-start;
      text-align: center;
    }
    .session-main{
      width: 910px;
      height: calc(100vh - 195px);
      background: #fff;
      padding: 10px 20px;
      position: relative;
      .vsflex{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        div{
          margin-right: 20px;
        }
      }
      .NullVsData{
        text-align: center;
        margin-top: 20px;
        font-size: 16px;
        color: #999999;
      }
      .vsList-normal{
        padding: 10px 10px 15px 10px;
        border-bottom: 0.5px solid #f2f2f2;
        margin: 10px 0 20px 0;
        cursor: pointer;
        color: #333333;
        .vstitle{
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 5px 0 10px 0;
          font-size: 20px;
          div{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            
            .vsflexone{
              margin-right: 20px;
            }
            .vsinfo{
              font-size: 16px;
              color: #666666;
            }
          }
         
        }
        .vsintro{
          font-size: 17px;
          color: #999999;
        }
       
      }
      .vsList-normal:hover{
        // box-shadow: 0 2px 2px rgba(0, 0, 0, .1);
        background-color: #f5f7f9;
      }
      .chatService{
        margin:10px 0px;
        background-color: #f5f7f9;
        padding:10px 10px;
        font-size:16px;
        color: #666;
        cursor: pointer;
        .UniMiddle{
          font-size: 18px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .btnblue{
            font-size: 16px;
            
          }
          .btnblue:hover{
            color: #10aeff;
          }
          
        }
      }
    }
  }
  .serviceList{
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    p{
      font-size: 18px;
      color: #333333;
      
      span{
        color: #666666;
        margin-left: 20px;
      }
      
    }
    p:nth-child(2){
      color: #666666;
      font-size: 16px;
    }
  }
  .serviceList:hover{
    background-color: #f2f2f2;
  }
  .serviceNull{
    text-align: center;
  }
}

</style>